// SidebarContext.js
import React, { createContext, useState, useContext } from "react";

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [sideBarColl, setSideBarColl] = useState(true);
  const [headerProps, setheaderProps] = useState(null);
  const [showSideBar, setShowSideBar] = useState(true);
  const [expandSideBar, setExpandSideBar] = useState(true);

  return (
    <SidebarContext.Provider
      value={{
        sideBarColl,
        setSideBarColl,
        headerProps,
        setheaderProps,
        showSideBar,
        setShowSideBar,
        expandSideBar,
        setExpandSideBar,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);
